import httpClient  from '../api';

export default {
    async getNotifyByUser() {
        let url = '/pbapi/api/GetNotifyByUser';
        return await httpClient.get(url);
    },

    setUserLastSeenNoti() {
        let url = '/pbapi/api/SetUserLastSeenNoti';
        return httpClient.post(url);
    },
}